import { PortalConfiguration } from '@atlas-engine-contrib/atlas-ui_contracts';

import { Portal } from '.';

export class ExtensionService {

  private portal: Portal;

  constructor(portalConfiguration: PortalConfiguration) {
    this.portal = new Portal(portalConfiguration);
  }

  public async loadExtensions(): Promise<void> {

    // "window.__getPortalExtensions" is defined in extensions.js (external script served by backend)

    // eslint-disable-next-line no-underscore-dangle
    if (window.__getPortalExtensions == null) {
      console.warn('Cannot load extensions: `window.__getPortalExtensions` is not defined');
      return;
    }

    // eslint-disable-next-line no-underscore-dangle
    const extensionsModules = window.__getPortalExtensions();

    for (const extensionModule of extensionsModules) {
      if (extensionModule.exports.onLoad) {

        try {
          await extensionModule.exports.onLoad(this.portal);
        } catch (error) {
          console.warn(`Could not load extension: ${extensionModule.name}`);
          console.error(error);
        }
      } else {
        console.warn(`Expected extension to export an \`onLoad\` hook: ${extensionModule.name}`);
      }
    }
  }

  public getPortal(): Portal {
    return this.portal;
  }
}
